module.exports = __webpack_public_path__ + "static/media/20.1635ed2d.jpg";